module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/VG0002-88c0dd9dbaeee19beaf4d461dda46492.png";